import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { BASE_URL } from '../utils'
import SetTitle from '../utils/set_title'
import Header from '../components/Headers/Header'

export default function BigQueryExporterFile() {
	SetTitle('BigQuery Exporter')
	const params = useParams()

	useEffect(() => {
    	downloadData()
  	}, [])

	const downloadData = () => {
		if (params?.id) {
			setTimeout(() => {
				window.location.href = BASE_URL+'/api/1/get-bigquery-exporter/'+params.id
				setTimeout(() => {
					window.location.href = '/bigquery-exporter'
				}, 5000)
			}, 1000)
		}
		else {
			setTimeout(() => {
				window.location.href = '/bigquery-exporter'
			}, 1000)
		}
	}

	return (
		<Header
			iconClass="ni ni-folder-17 text-white"
			title="BigQuery Exporter"
			description="Download in corso..."
		/>
	)
}
